import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { HttpData, HttpNoData } from "../../../../Core";

export default function CoatingModalEdit({
  jwt,
  coating,
  show,
  onHide,
  onUpdated,
  onDeleted,
}) {
  const [name, setName] = useState("");

  useEffect(() => {
    if (coating) {
      setName(coating.name || "");
    }
  }, [coating]);

  const onSubmit = async (e) => {
    e.preventDefault();

    const response = await HttpData(
      `/api/v1/calculateOrderCost/coatings/${coating.id}`,
      "PUT",
      jwt,
      {
        name: name,
      },
    );

    if (response.statusSuccessful) {
      onUpdated({
        ...coating,
        name: name,
      });
    } else {
      alert(`Не получилось обновить: ${response.error}`);
    }
  };

  const onDelete = async () => {
    const response = await HttpNoData(
      `/api/v1/calculateOrderCost/coatings/${coating.id}`,
      "DELETE",
      jwt,
    );

    if (response.statusSuccessful) {
      onDeleted();
    } else {
      alert(`Не получилось удалить: ${response.error}`);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={onSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Редактирование нанесения</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Название</Form.Label>
            <Form.Control
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Отмена
          </Button>
          <Button variant="danger" onClick={onDelete}>
            Удалить
          </Button>
          <Button variant="success" type="submit">
            Сохранить
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
